// extracted by mini-css-extract-plugin
export default {"page":"InfoPage_page__6MmRc","body":"InfoPage_body__2CmZZ","contentWrapper":"InfoPage_contentWrapper__SNDzs","additionalImg":"InfoPage_additionalImg__JpRIO"};